export default {

  'apparel-and-footwear': {
    title: 'Attach for Apparel & Footwear',
    subtitle: '4x lift in checkouts with MikMak compared to a regular product details page',
    logos: [
      'under-armour',
      'banana-republic',
      'levis',
      'zappos'
    ],
    demos: [
      {
        attachProduct: 'cart',
        brand: 'zappos',
        cta: 'Request a demo of Cart',
        orientation: 'right',
        backgroundColor: '#fbf9f9',
        headline: 'Zappos + MikMak',
        text: [
          'Zappos saw few add-to-carts from traffic referred to their product details page from social. With Attach Cart, they see <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">20%</span> of users add-to-cart.',
        ],
        bullets: [
          'Add-to-cart made easy',
          'Integrates with Amazon, Target, Shopify, Walmart, Demandware, Magento & more',
          'Full funnel attribution',
          'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'
        ],
        videoSrc: 'https://s3.amazonaws.com/attach-videos/LOigegATCqqQBR5A8WyW_Zappos Attach - 7.15.17_IP7.mp4'
      }
    ]
  },

  'beauty': {
    title: 'Attach for Beauty & Personal care',
    subtitle: '4x lift in add-to-carts with MikMak compared to a regular product details page',
    logos: [
      // 'olay',
      'benefit-cosmetics',
      'revlon',
      'loreal',
      'estee-lauder',
      'dove',
      // 'birchbox',
      // 'pandg',
      'unilever'
    ],
    demos: [
      {
        attachProduct: 'multicart',
        brand: 'colgate',
        cta: 'Request a demo of MultiCart',
        orientation: 'right',
        backgroundColor: 'white',
        headline: 'GLAMGLOW + MikMak',
        text: [
          'Prior to MikMak, GLAMGLOW had to segment their traffic without knowing where customers preferred to shop which resulted in media inefficiencies and low conversion rates.'
        ],
        bullets: [
          'GLAMGLOW launched MikMak Attach MultiCart supporting Sephora.com & GLAMGLOW.com. MultiCart allowed the brand to achieve a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">66%</span> add-to-cart rate, over <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">5.5x</span> MikMak’s beauty benchmark.',
          'The brand also gained segmented shopper audiences in their ad manager to use for future Sephora and DTC prospecting and retargeting ad campaigns. MikMak audiences out perform brands’ native audiences.'
        ],
        videoSrc: 'https://s3.amazonaws.com/attach-videos/2KIAgV6fTaOcHuSPUT4c_glamglow_sm.mov'
      }
    ]
  },

  'food-and-beverage': {
    title: 'Attach for Food & Beverage',
    subtitle: '17% of shoppers hit add-to-cart within Attach for CPG products',
    logos: [
      'general-mills',
      'nestle',
      'mondelez',
      'pepperidge-farm'
    ],
    demos: [
      {
        attachProduct: 'cart',
        brand: 'pepperidge-farm',
        cta: 'Request a demo of Cart',
        orientation: 'right',
        backgroundColor: 'white',
        headline: 'Pepperidge Farm + MikMak',
        text: [
          'Pepperidge Farm came to MikMak to enable frictionless shopping amongst influencers supporting their back-to-school and holiday campaigns. MikMak Attach identified which influencers drove the strongest conversion amongst Amazon, Target and Walmart. Pepperidge Farm learned that there was an <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">11x</span> conversion difference amongst influencers, allowing them to reallocate spend towards the top. performing influencers in future campaigns. '
        ],
        bullets: [
          'Add-to-cart made easy',
          'Integrations with Shopify, Demandware, Magento, Amazon, Ulta, Walmart and more',
          'Control your brand expression and data at the product page level even when you don’t own the eComm cart',
          'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'
        ],
        videoSrc: '//s3.amazonaws.com/attach-videos/sAcJJeyYQkKesoVLDS6C_@ministylehacker_Goldfish_AmazonWalmart.mov'
      }
    ]
  },

  'consumer-electronics': {
    title: 'Attach for Consumer Electronics',
    subtitle: '4x lift in checkouts with MikMak compared to a regular product details page',
    logos: [
      'bose',
      'gopro',
      't-mobile'
    ],
    demos: [
      {
        attachProduct: 'cart',
        brand: 'bose',
        cta: 'Request a demo of Cart',
        orientation: 'left',
        backgroundColor: '#fbf9f9',
        headline: 'Bose + MikMak',
        text: [
          'Bose came to MikMak to increase conversion from social media referral traffic. MikMak drives a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">5x</span> lift in add-to-carts compared to its own eCommerce product details page.',
        ],
        bullets: [
          'Add-to-cart made easy',
          'Integrates with Amazon, Target, Shopify, Walmart, Demandware, Magento & more',
          'Full funnel attribution',
          'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'
        ],
        videoSrc: 'https://s3.amazonaws.com/attach-videos/N3opeHYeS96bJ7ZlNXaj_Bose%20Sponsored%20Instagram%20Story.mp4'
      }
    ]
  },

  'big-box-ecommerce': {
    title: 'For Brands sold at Big Box eCommerce',
    subtitle: 'Drive Add-to-Carts at big box retailer sites like Amazon, Walmart and Target ',
    logos: [
      'estee-lauder',
      'loreal',
      'revlon',
      'lvmh',
      'unilever',
      'general-mills',
      'mondelez',
      'pepperidge-farm'
    ],
    demos: [
      {
        attachProduct: 'cart',
        brand: 'pepperidge-farm',
        cta: 'Request a demo of Cart',
        orientation: 'right',
        backgroundColor: '#fbf9f9',
        headline: 'Pepperidge Farm + MikMak',
        text: [
          'Pepperidge Farm came to MikMak in order to leverage their large, active community of influencers.',
          'During a Holiday campaign to promote Goldfish and Milano crackers, Pepperidge Farm influencers launched Attach Cart units all over social media, giving Pepperidge Farm organic followers several ways to shop.'
        ],
        bullets: [
          'Add-to-cart made easy',
          'Integrates with Amazon, Target, Shopify, Walmart, Demandware, Magento & more',
          'Full funnel attribution',
          'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'
        ],
        videoSrc: '//s3.amazonaws.com/attach-videos/Pg4FZ3RmG7u7ybtbKxwS_Goldfish x TargetDoesItAgain (Influencer) Instagram Story Demo.mov'
      }
    ]
  },

  'working-with-influencers': {
    title: 'For Working with Influencers',
    subtitle: 'Discover which influencers drive add-to-carts',
    logos: [
      'benefit-cosmetics',
      // 'dr-brandt',
      'loreal',
      'oreo',
      'pepperidge-farm',
      'revlon',
      'unilever',
      'zappos'
    ],
    demos: [
      {
        attachProduct: 'multicart',
        brand: 'colgate-optic-white',
        cta: 'Request a demo of Cart',
        orientation: 'right',
        backgroundColor: '#fbf9f9',
        headline: 'Colgate + MikMak',
        text: [
          'Prior to MikMak, Colgate Optic White had no idea which influencers had the ability to drive purchase intent at major eRetailers.'
        ],
        bullets: [
          'Optic White launched an influencer campaign with MikMak Attach MultiCart. The brand saw a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">3x</span> spread amongst influencers ability to drive add-to-carts, meaning some drove a ton of add-to-carts while others drove close to none.',
          'On average influencers drove a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">20%</span> add-to-cart',
          'The brand also gained segmented shopper audiences in their ad manager to use for future Amazon, Target and Walmart prospecting and retargeting ad campaigns. MikMak audiences out perform brands’ native audiences.'
        ],
        videoSrc: 'https://s3.amazonaws.com/attach-videos/t9vuxDkSGK99jjmyIAww_optic_white_sm.mov'
      }
    ]
  },

  'direct-to-consumer-brands': {
    title: 'For Direct-to-Consumer Brands',
    subtitle: 'Native video shopping experience that causes consumers to add to cart',
    logos: [
      // 'dollar-shave-club',
      // 'birchbox',
      'levis',
      'under-armour',
      'zappos',
      'benefit-cosmetics'
    ],
    demos: [
      {
        attachProduct: 'cart',
        brand: 'levis',
        cta: 'Request a demo of Cart',
        orientation: 'right',
        backgroundColor: '#fbf9f9',
        headline: 'Levi\'s + MikMak',
        text: [
          'Prior to MikMak, Levi’s was seeing high bounce rates and low conversion when traffic arrived to their website from social.',
        ],
        bullets: [
          'With MikMak, Levi’s saw a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">2x</span> lift in add-to-carts and a <span style="background: #6fcc40; color: white; padding: 0 4px; border-radius: 2px;">1.6x</span> reduction in bounce rate.'
        ],
        videoSrc: 'https://s3.amazonaws.com/attach-videos/LT50fN9RTiSUs7hfkdQ2_levis_mobile_sm.mov'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./client/store/imports/VerticalPageData.js